(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kc-configurable-footer"] && !Shopify.designMode) return;
  try {
    
  (()=>{const sync=()=>document.querySelectorAll('.kc-footer__group').forEach(group=>matchMedia('(max-width:767px)').matches?group.removeAttribute('open'):group.setAttribute('open',''));document.readyState==='loading'?document.addEventListener('DOMContentLoaded',sync):sync();addEventListener('resize',sync);document.addEventListener('shopify:section:load',sync)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-mobile-product-nav"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mobile-product-nav')) {
  customElements.define('mobile-product-nav', class extends HTMLElement {
    connectedCallback() {
      this.buttons = [...this.querySelectorAll('[data-target]')];
      this.media = window.matchMedia('(max-width: 767px)');
      this.selectors = {
        product: '[id$="__main-product"]',
        reviews: '#judgeme_product_reviews',
        details: '[id$="__kc_features"]',
        'how-to-use': '[id$="__kc_guides"]'
      };
      this.targets = this.buttons.map((button) => ({
        button,
        element: document.querySelector(this.selectors[button.dataset.target])
      })).filter((item) => item.element);
      this.onScroll = () => {
        if (!this.media.matches) {
          this.classList.remove('is-visible');
          return;
        }
        this.classList.toggle('is-visible', window.scrollY > Number(this.dataset.showAfter || 80));
        const offset = this.offsetHeight + this.headerHeight() + 24;
        let current = this.targets[0];
        let currentTop = Number.NEGATIVE_INFINITY;
        this.targets.forEach((item) => {
          const top = item.element.getBoundingClientRect().top;
          if (top <= offset && top > currentTop) {
            current = item;
            currentTop = top;
          }
        });
        this.buttons.forEach((button) => button.classList.toggle('is-active', current?.button === button));
      };
      this.onClick = (event) => {
        const button = event.target.closest('[data-target]');
        if (!button) return;
        const target = document.querySelector(this.selectors[button.dataset.target]);
        if (!target) return;
        const top = target.getBoundingClientRect().top + window.scrollY - this.headerHeight() - this.offsetHeight - 8;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      };
      this.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();
    }

    headerHeight() {
      const value = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      return Number.parseFloat(value) || 60;
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
